import { render, staticRenderFns } from "./quotition.vue?vue&type=template&id=a61c7fd6"
import script from "./quotition.vue?vue&type=script&lang=js"
export * from "./quotition.vue?vue&type=script&lang=js"
import style0 from "./quotition.vue?vue&type=style&index=0&id=a61c7fd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports